module.exports = __webpack_public_path__ + "img/cert_1.22546185.jpg";